/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as HistoryIndexRouteImport } from './routes/history/index'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as TemplatesTemplateIdRouteImport } from './routes/templates/$templateId'
import { Route as HistoryFormIdRouteImport } from './routes/history/$formId'
import { Route as TemplatesTemplateIdIndexRouteImport } from './routes/templates/$templateId/index'
import { Route as SettingsStorageIndexRouteImport } from './routes/settings/storage/index'
import { Route as HistoryFormIdIndexRouteImport } from './routes/history/$formId/index'
import { Route as SettingsStorageRecordingsRouteImport } from './routes/settings/storage/recordings'
import { Route as SettingsStoragePhotosRouteImport } from './routes/settings/storage/photos'
import { Route as HistoryFormIdCategoryIdRouteImport } from './routes/history/$formId/$categoryId'
import { Route as HistoryFormIdCategoryIdIndexRouteImport } from './routes/history/$formId/$categoryId/index'
import { Route as HistoryFormIdCategoryIdSectionIdRouteImport } from './routes/history/$formId/$categoryId/$sectionId'
import { Route as HistoryFormIdCategoryIdSectionIdIndexRouteImport } from './routes/history/$formId/$categoryId/$sectionId/index'
import { Route as HistoryFormIdCategoryIdSectionIdResultsRouteImport } from './routes/history/$formId/$categoryId/$sectionId/results'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryIndexRoute = HistoryIndexRouteImport.update({
  id: '/history/',
  path: '/history/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutIndexRoute = AboutIndexRouteImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTemplateIdRoute = TemplatesTemplateIdRouteImport.update({
  id: '/templates/$templateId',
  path: '/templates/$templateId',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryFormIdRoute = HistoryFormIdRouteImport.update({
  id: '/history/$formId',
  path: '/history/$formId',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTemplateIdIndexRoute =
  TemplatesTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => TemplatesTemplateIdRoute,
  } as any)
const SettingsStorageIndexRoute = SettingsStorageIndexRouteImport.update({
  id: '/settings/storage/',
  path: '/settings/storage/',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryFormIdIndexRoute = HistoryFormIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HistoryFormIdRoute,
} as any)
const SettingsStorageRecordingsRoute =
  SettingsStorageRecordingsRouteImport.update({
    id: '/settings/storage/recordings',
    path: '/settings/storage/recordings',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsStoragePhotosRoute = SettingsStoragePhotosRouteImport.update({
  id: '/settings/storage/photos',
  path: '/settings/storage/photos',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryFormIdCategoryIdRoute = HistoryFormIdCategoryIdRouteImport.update({
  id: '/$categoryId',
  path: '/$categoryId',
  getParentRoute: () => HistoryFormIdRoute,
} as any)
const HistoryFormIdCategoryIdIndexRoute =
  HistoryFormIdCategoryIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HistoryFormIdCategoryIdRoute,
  } as any)
const HistoryFormIdCategoryIdSectionIdRoute =
  HistoryFormIdCategoryIdSectionIdRouteImport.update({
    id: '/$sectionId',
    path: '/$sectionId',
    getParentRoute: () => HistoryFormIdCategoryIdRoute,
  } as any)
const HistoryFormIdCategoryIdSectionIdIndexRoute =
  HistoryFormIdCategoryIdSectionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => HistoryFormIdCategoryIdSectionIdRoute,
  } as any)
const HistoryFormIdCategoryIdSectionIdResultsRoute =
  HistoryFormIdCategoryIdSectionIdResultsRouteImport.update({
    id: '/results',
    path: '/results',
    getParentRoute: () => HistoryFormIdCategoryIdSectionIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/history/$formId': typeof HistoryFormIdRouteWithChildren
  '/templates/$templateId': typeof TemplatesTemplateIdRouteWithChildren
  '/about': typeof AboutIndexRoute
  '/history': typeof HistoryIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/history/$formId/$categoryId': typeof HistoryFormIdCategoryIdRouteWithChildren
  '/settings/storage/photos': typeof SettingsStoragePhotosRoute
  '/settings/storage/recordings': typeof SettingsStorageRecordingsRoute
  '/history/$formId/': typeof HistoryFormIdIndexRoute
  '/settings/storage': typeof SettingsStorageIndexRoute
  '/templates/$templateId/': typeof TemplatesTemplateIdIndexRoute
  '/history/$formId/$categoryId/$sectionId': typeof HistoryFormIdCategoryIdSectionIdRouteWithChildren
  '/history/$formId/$categoryId/': typeof HistoryFormIdCategoryIdIndexRoute
  '/history/$formId/$categoryId/$sectionId/results': typeof HistoryFormIdCategoryIdSectionIdResultsRoute
  '/history/$formId/$categoryId/$sectionId/': typeof HistoryFormIdCategoryIdSectionIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutIndexRoute
  '/history': typeof HistoryIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/settings/storage/photos': typeof SettingsStoragePhotosRoute
  '/settings/storage/recordings': typeof SettingsStorageRecordingsRoute
  '/history/$formId': typeof HistoryFormIdIndexRoute
  '/settings/storage': typeof SettingsStorageIndexRoute
  '/templates/$templateId': typeof TemplatesTemplateIdIndexRoute
  '/history/$formId/$categoryId': typeof HistoryFormIdCategoryIdIndexRoute
  '/history/$formId/$categoryId/$sectionId/results': typeof HistoryFormIdCategoryIdSectionIdResultsRoute
  '/history/$formId/$categoryId/$sectionId': typeof HistoryFormIdCategoryIdSectionIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/history/$formId': typeof HistoryFormIdRouteWithChildren
  '/templates/$templateId': typeof TemplatesTemplateIdRouteWithChildren
  '/about/': typeof AboutIndexRoute
  '/history/': typeof HistoryIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/history/$formId/$categoryId': typeof HistoryFormIdCategoryIdRouteWithChildren
  '/settings/storage/photos': typeof SettingsStoragePhotosRoute
  '/settings/storage/recordings': typeof SettingsStorageRecordingsRoute
  '/history/$formId/': typeof HistoryFormIdIndexRoute
  '/settings/storage/': typeof SettingsStorageIndexRoute
  '/templates/$templateId/': typeof TemplatesTemplateIdIndexRoute
  '/history/$formId/$categoryId/$sectionId': typeof HistoryFormIdCategoryIdSectionIdRouteWithChildren
  '/history/$formId/$categoryId/': typeof HistoryFormIdCategoryIdIndexRoute
  '/history/$formId/$categoryId/$sectionId/results': typeof HistoryFormIdCategoryIdSectionIdResultsRoute
  '/history/$formId/$categoryId/$sectionId/': typeof HistoryFormIdCategoryIdSectionIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/history/$formId'
    | '/templates/$templateId'
    | '/about'
    | '/history'
    | '/settings'
    | '/templates'
    | '/history/$formId/$categoryId'
    | '/settings/storage/photos'
    | '/settings/storage/recordings'
    | '/history/$formId/'
    | '/settings/storage'
    | '/templates/$templateId/'
    | '/history/$formId/$categoryId/$sectionId'
    | '/history/$formId/$categoryId/'
    | '/history/$formId/$categoryId/$sectionId/results'
    | '/history/$formId/$categoryId/$sectionId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/history'
    | '/settings'
    | '/templates'
    | '/settings/storage/photos'
    | '/settings/storage/recordings'
    | '/history/$formId'
    | '/settings/storage'
    | '/templates/$templateId'
    | '/history/$formId/$categoryId'
    | '/history/$formId/$categoryId/$sectionId/results'
    | '/history/$formId/$categoryId/$sectionId'
  id:
    | '__root__'
    | '/'
    | '/history/$formId'
    | '/templates/$templateId'
    | '/about/'
    | '/history/'
    | '/settings/'
    | '/templates/'
    | '/history/$formId/$categoryId'
    | '/settings/storage/photos'
    | '/settings/storage/recordings'
    | '/history/$formId/'
    | '/settings/storage/'
    | '/templates/$templateId/'
    | '/history/$formId/$categoryId/$sectionId'
    | '/history/$formId/$categoryId/'
    | '/history/$formId/$categoryId/$sectionId/results'
    | '/history/$formId/$categoryId/$sectionId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HistoryFormIdRoute: typeof HistoryFormIdRouteWithChildren
  TemplatesTemplateIdRoute: typeof TemplatesTemplateIdRouteWithChildren
  AboutIndexRoute: typeof AboutIndexRoute
  HistoryIndexRoute: typeof HistoryIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
  SettingsStoragePhotosRoute: typeof SettingsStoragePhotosRoute
  SettingsStorageRecordingsRoute: typeof SettingsStorageRecordingsRoute
  SettingsStorageIndexRoute: typeof SettingsStorageIndexRoute
}

declare module '@tanstack/solid-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/': {
      id: '/history/'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about/': {
      id: '/about/'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/$templateId': {
      id: '/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof TemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/$formId': {
      id: '/history/$formId'
      path: '/history/$formId'
      fullPath: '/history/$formId'
      preLoaderRoute: typeof HistoryFormIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/$templateId/': {
      id: '/templates/$templateId/'
      path: '/'
      fullPath: '/templates/$templateId/'
      preLoaderRoute: typeof TemplatesTemplateIdIndexRouteImport
      parentRoute: typeof TemplatesTemplateIdRoute
    }
    '/settings/storage/': {
      id: '/settings/storage/'
      path: '/settings/storage'
      fullPath: '/settings/storage'
      preLoaderRoute: typeof SettingsStorageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/$formId/': {
      id: '/history/$formId/'
      path: '/'
      fullPath: '/history/$formId/'
      preLoaderRoute: typeof HistoryFormIdIndexRouteImport
      parentRoute: typeof HistoryFormIdRoute
    }
    '/settings/storage/recordings': {
      id: '/settings/storage/recordings'
      path: '/settings/storage/recordings'
      fullPath: '/settings/storage/recordings'
      preLoaderRoute: typeof SettingsStorageRecordingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/storage/photos': {
      id: '/settings/storage/photos'
      path: '/settings/storage/photos'
      fullPath: '/settings/storage/photos'
      preLoaderRoute: typeof SettingsStoragePhotosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history/$formId/$categoryId': {
      id: '/history/$formId/$categoryId'
      path: '/$categoryId'
      fullPath: '/history/$formId/$categoryId'
      preLoaderRoute: typeof HistoryFormIdCategoryIdRouteImport
      parentRoute: typeof HistoryFormIdRoute
    }
    '/history/$formId/$categoryId/': {
      id: '/history/$formId/$categoryId/'
      path: '/'
      fullPath: '/history/$formId/$categoryId/'
      preLoaderRoute: typeof HistoryFormIdCategoryIdIndexRouteImport
      parentRoute: typeof HistoryFormIdCategoryIdRoute
    }
    '/history/$formId/$categoryId/$sectionId': {
      id: '/history/$formId/$categoryId/$sectionId'
      path: '/$sectionId'
      fullPath: '/history/$formId/$categoryId/$sectionId'
      preLoaderRoute: typeof HistoryFormIdCategoryIdSectionIdRouteImport
      parentRoute: typeof HistoryFormIdCategoryIdRoute
    }
    '/history/$formId/$categoryId/$sectionId/': {
      id: '/history/$formId/$categoryId/$sectionId/'
      path: '/'
      fullPath: '/history/$formId/$categoryId/$sectionId/'
      preLoaderRoute: typeof HistoryFormIdCategoryIdSectionIdIndexRouteImport
      parentRoute: typeof HistoryFormIdCategoryIdSectionIdRoute
    }
    '/history/$formId/$categoryId/$sectionId/results': {
      id: '/history/$formId/$categoryId/$sectionId/results'
      path: '/results'
      fullPath: '/history/$formId/$categoryId/$sectionId/results'
      preLoaderRoute: typeof HistoryFormIdCategoryIdSectionIdResultsRouteImport
      parentRoute: typeof HistoryFormIdCategoryIdSectionIdRoute
    }
  }
}

interface HistoryFormIdCategoryIdSectionIdRouteChildren {
  HistoryFormIdCategoryIdSectionIdResultsRoute: typeof HistoryFormIdCategoryIdSectionIdResultsRoute
  HistoryFormIdCategoryIdSectionIdIndexRoute: typeof HistoryFormIdCategoryIdSectionIdIndexRoute
}

const HistoryFormIdCategoryIdSectionIdRouteChildren: HistoryFormIdCategoryIdSectionIdRouteChildren =
  {
    HistoryFormIdCategoryIdSectionIdResultsRoute:
      HistoryFormIdCategoryIdSectionIdResultsRoute,
    HistoryFormIdCategoryIdSectionIdIndexRoute:
      HistoryFormIdCategoryIdSectionIdIndexRoute,
  }

const HistoryFormIdCategoryIdSectionIdRouteWithChildren =
  HistoryFormIdCategoryIdSectionIdRoute._addFileChildren(
    HistoryFormIdCategoryIdSectionIdRouteChildren,
  )

interface HistoryFormIdCategoryIdRouteChildren {
  HistoryFormIdCategoryIdSectionIdRoute: typeof HistoryFormIdCategoryIdSectionIdRouteWithChildren
  HistoryFormIdCategoryIdIndexRoute: typeof HistoryFormIdCategoryIdIndexRoute
}

const HistoryFormIdCategoryIdRouteChildren: HistoryFormIdCategoryIdRouteChildren =
  {
    HistoryFormIdCategoryIdSectionIdRoute:
      HistoryFormIdCategoryIdSectionIdRouteWithChildren,
    HistoryFormIdCategoryIdIndexRoute: HistoryFormIdCategoryIdIndexRoute,
  }

const HistoryFormIdCategoryIdRouteWithChildren =
  HistoryFormIdCategoryIdRoute._addFileChildren(
    HistoryFormIdCategoryIdRouteChildren,
  )

interface HistoryFormIdRouteChildren {
  HistoryFormIdCategoryIdRoute: typeof HistoryFormIdCategoryIdRouteWithChildren
  HistoryFormIdIndexRoute: typeof HistoryFormIdIndexRoute
}

const HistoryFormIdRouteChildren: HistoryFormIdRouteChildren = {
  HistoryFormIdCategoryIdRoute: HistoryFormIdCategoryIdRouteWithChildren,
  HistoryFormIdIndexRoute: HistoryFormIdIndexRoute,
}

const HistoryFormIdRouteWithChildren = HistoryFormIdRoute._addFileChildren(
  HistoryFormIdRouteChildren,
)

interface TemplatesTemplateIdRouteChildren {
  TemplatesTemplateIdIndexRoute: typeof TemplatesTemplateIdIndexRoute
}

const TemplatesTemplateIdRouteChildren: TemplatesTemplateIdRouteChildren = {
  TemplatesTemplateIdIndexRoute: TemplatesTemplateIdIndexRoute,
}

const TemplatesTemplateIdRouteWithChildren =
  TemplatesTemplateIdRoute._addFileChildren(TemplatesTemplateIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HistoryFormIdRoute: HistoryFormIdRouteWithChildren,
  TemplatesTemplateIdRoute: TemplatesTemplateIdRouteWithChildren,
  AboutIndexRoute: AboutIndexRoute,
  HistoryIndexRoute: HistoryIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
  SettingsStoragePhotosRoute: SettingsStoragePhotosRoute,
  SettingsStorageRecordingsRoute: SettingsStorageRecordingsRoute,
  SettingsStorageIndexRoute: SettingsStorageIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
